import React from "react";
import Slider from "react-slick";
import BannerItems from "../data/data.json";
import { SimpleImg } from 'react-simple-img';

var settings = {
  dots: true,
  arrows: false,
  autoplaySpeed: 2000,
  swipeToSlide: true,
};

export const PromoSliders = () => {
  const onlyPromo = BannerItems.products.filter(item => item.categ === "promo");
  return (
    <div className="promo-slider">
      <Slider {...settings} >
        {onlyPromo.map(banners => {
          return <div key={banners.id}>
            
            <SimpleImg height={126} src={banners.img} alt={ banners.alt } placeholder="#dedede" />
          </div>
        })}
      </Slider>
      <div className="shadow"></div>
    </div>
  );
};